var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import layoutComponentsDictionary from "./layoutComponentsDictionary";
import "./layoutComponents";
import { useLogger } from "@/utils/loggerService";
import copy from "fast-copy";
import { RecordContext } from "./recordContext";
/**
 * <b>Composant pour le rendu d'un élément de layout</b>
 *
 * @param param0
 * @returns
 */
export function LayoutComponentDisplay(_a) {
    var _b;
    var module = _a.module, viewType = _a.viewType, fieldDefs = _a.fieldDefs, record = _a.record, fetchedRecord = _a.fetchedRecord, layouts = _a.layouts, onHandleUpdate = _a.onHandleUpdate, validations = _a.validations, isStudioField = _a.isStudioField, isSelected = _a.isSelected, layoutParent = _a.layoutParent, viewScreen = _a.viewScreen;
    var logger = useLogger().logger;
    var _c = useState(copy(record)), editedRecord = _c[0], setEditedRecord = _c[1];
    var updateRecord = function (edited) {
        setEditedRecord(edited);
        onHandleUpdate && onHandleUpdate(edited);
    };
    var componentIndex = 0;
    if (layouts && layouts.type) {
        var componentName = layouts.type || "";
        var layoutComponent = layoutComponentsDictionary.getLayoutComponent(componentName);
        if (layoutComponent) {
            logger.debug("[LAYOUT] - Utilisation du composant \"".concat(layoutComponent.name, "\" pour afficher le type \"").concat(componentName, "\"."));
            return React.createElement(layoutComponent, {
                key: "element_".concat(componentIndex++),
                module: module,
                viewType: viewType,
                fieldDefs: fieldDefs,
                record: record,
                fetchedRecord: fetchedRecord,
                layouts: [layouts],
                onHandleUpdate: onHandleUpdate,
                validations: validations,
                isStudioField: isStudioField,
                isSelected: isSelected,
                layoutParent: layoutParent,
                viewScreen: viewScreen,
            });
        }
    }
    return (_jsx(_Fragment, { children: layouts &&
            ((_b = layouts === null || layouts === void 0 ? void 0 : layouts.components) === null || _b === void 0 ? void 0 : _b.map(function (l) {
                var componentName = l.type || "";
                var layoutComponent = layoutComponentsDictionary.getLayoutComponent(componentName);
                if (layoutComponent) {
                    logger.debug("[LAYOUT] - Utilisation du composant \"".concat(layoutComponent.name, "\" pour afficher le type \"").concat(componentName, "\"."));
                    /*
                  return React.createElement(
                    layoutComponent as ComponentClass,
                    {
                      key: `element_${componentIndex++}`,
                      module,
                      viewType,
                      record,
                      fetchedRecord,
                      layouts: [l],
                    } as React.ClassAttributes<{}>
                  );
                  */
                    return (_jsx(RecordContext.Provider, __assign({ value: editedRecord }, { children: _jsx(LayoutComponentDisplay, { module: module, viewType: viewType, fieldDefs: fieldDefs, record: editedRecord, fetchedRecord: fetchedRecord, layouts: l || [], onHandleUpdate: updateRecord, validations: validations, isStudioField: isStudioField, isSelected: isSelected, layoutParent: null, viewScreen: viewScreen }, "element_".concat(componentIndex++)) })));
                }
                else if (componentName === "") {
                    logger.debug("[LAYOUT] - Pas de type de layout fourni, les enfants seront affichés directement sur plusieurs lignes.", l);
                    return (_jsx(LayoutComponentDisplay, { module: module, viewType: viewType, record: editedRecord, fetchedRecord: fetchedRecord, layouts: l.components || [], onHandleUpdate: updateRecord, validations: validations, viewScreen: viewScreen }, "element_".concat(componentIndex++)));
                }
                if (process.env.NODE_ENV === "development") {
                    logger.debug("[LAYOUT] - Composant inconnu : \"".concat(componentName, "\"."), l);
                    return (_jsxs("p", { children: ["Unknown component: ".concat(componentName), _jsx("br", {})] }, "element_".concat(componentIndex++)));
                }
                return _jsx(_Fragment, {});
            })) }));
}
